import Container from "../components/Container";
import selfPicture from "../image/self.png";

const Main = () => {
    return (
        <>
            <Container className="flex min-h-screen w-full relative text-eslate">
                <div className="bg-eblack text-eslate name font-semibold text-center pt-10 pb-5 text-2xl absolute z-10 top-0 w-full">
                    EMERALDDD
                    {/* Comming soon: <div className="flex justify-center text-sm font-thin">
                        <div className="hover:font-normal">
                            Tiếng Việt
                        </div>
                        <div className="hover:font-normal">
                            English
                        </div>
                    </div> */}
                </div>
                <div className="pl-24 pr-32">
                    <div className="flex-1 flex flex-col min-h-screen">
                        <div className="flex-1 flex items-center">
                            <div className="">
                                <div className="text-eslate1 flex flex-col gap-3 max-w-[80%] text-lg">
                                    <div className="text-2xl text-eslate">
                                        Hi! I'm
                                    </div>
                                    <div className="text-5xl font-bold text-eslate">
                                        Tung Lam
                                    </div>
                                    <div>
                                        But you can call me <span className="text-eslate font-semibold">Austin</span>!

                                    </div>
                                    <div>
                                        Nice to meet you! 
                                        I'm a second-year Computer Science student at RMIT University. I focus on AI&ML, as well as a bit of cyber assurance. I can also do software development (including web and software).
                                    </div>
                                    <div>
                                        I enjoy learning new algorithms and data structures. I also have some C++ classes for competitive programming.
                                    </div>
                                    <div>
                                        My passion is to integrate technology into education, making learning more engaging for students and delivering content more conveniently for teachers.
                                    </div>
                                    <a className="w-min" href="mailto:me@tunglamnguyenkhac.com">
                                        <div className="border-2 border-eslate w-max py-1 px-4 text-eslate my-4 cursor-pointer hover:bg-eslate hover:text-eblack transition">
                                            Contact me via email: <div className="inline-block font-semibold">me@tunglamnguyenkhac.com</div>
                                        </div>
                                    </a>
                                    <div className="flex gap-5">
                                        <a href="https://github.com/emeralddd">
                                            <i class="fa fa-github text-3xl w-10 h-10 leading-10 text-center border-2 hover:text-eslate hover:border-eslate bg-eslate text-eblack hover:bg-eblack transition" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.linkedin.com/in/darkemeralddd/">
                                            <i class="fa fa-linkedin text-3xl w-10 h-10 leading-10 text-center border-2 hover:text-eslate hover:border-eslate bg-eslate text-eblack hover:bg-eblack transition" aria-hidden="true"></i>
                                        </a>
                                        <a href="https://www.facebook.com/darkemeralddd">
                                            <i class="fa fa-facebook text-3xl w-10 h-10 leading-10 text-center border-2 hover:text-eslate hover:border-eslate bg-eslate text-eblack hover:bg-eblack transition" aria-hidden="true"></i>
                                        </a>
                                    </div>
                                </div>

                            </div>


                            <div>
                                <div className="bg-[#29292B] translate-x-4 translate-y-4">
                                    <img src={selfPicture} alt="This is me!" className=" -translate-x-7 -translate-y-7 w-[46rem]" />
                                </div>
                            </div>
                        </div>

                    </div>

                </div>

            </Container >
            <Container bgColor="bg-eslate" className="text-eblack">
                <div className="text-xl text-center py-10">
                    🏗️ Oh hi! I'm building here. Something is coming soon at this area ... 🚧
                </div>
            </Container>
        </>
    )
}

export default Main;